import { FC } from 'react'

import {
  Card
} from 'components'
import { useGet } from 'hooks'
import { FormProvider, useForm } from 'react-hook-form'
import { IEntityGST } from 'services/core/genericEntityGST'
import { IContratoItensSegurancaResponse } from 'services/GST/PesquisaPorContrato'
import { SPACING } from 'utils'

import { UseSearchByContract } from '../../context'
import { DadosContratoCollapse } from './components/dadosContratoCollapse'
import { DocumentacaoCollpase } from './components/documentacaoCollapse'
import { IForm } from './types'

export const GerenciamentoSeguranca: FC = () => {
  const methods = useForm<IForm>()
  const { idContratoSelecionado } = UseSearchByContract()
  const {
    data: tableData,
    isFirstGet,
    refresh: refreshTable
  } = useGet<{}, IEntityGST<IContratoItensSegurancaResponse[]>>({
    api: 'Gst',
    isPaginated: true,
    params: {},
    url: `itemSegurancaContrato/GetDocumentacao/${idContratoSelecionado}`
  })

  return (
    <FormProvider {...methods}>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <DadosContratoCollapse isFirstGet={isFirstGet} />
        <DocumentacaoCollpase 
          oldTableData={tableData?.entity} 
          isFirstGet={isFirstGet}
          refreshTable={refreshTable}
        />
      </Card>
    </FormProvider>
  )
}
export default GerenciamentoSeguranca
